import {DeleteRefundProcedureParams} from 'domain/usecases/private/refund/request/delete-procedure';
import {makeDeleteRefundProcedure} from 'main/factories/usecases/private/refund/request/delete-procedure';

export async function deleteProcedure(params: DeleteRefundProcedureParams) {
	const deleteRefundProcedure = makeDeleteRefundProcedure(params);
	return deleteRefundProcedure.delete();
}
